// extracted by mini-css-extract-plugin
export default {"root":"FileUpload_root__2pGUz","zone":"FileUpload_zone__ZLeY2","file":"FileUpload_file__SeQ5E"};